namespace Matrix.Scheduling {
    export interface CalendarEntryRow {
        CalendarEntryId?: number;
        CalendarCode?: string;
        EntryDate?: string;
        Description?: string;
        Exclude?: boolean;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        CalendarCodeName?: string;
        CalendarCodeRowId?: number;
    }

    export namespace CalendarEntryRow {
        export const idProperty = 'CalendarEntryId';
        export const nameProperty = 'CalendarCode';
        export const localTextPrefix = 'Scheduling.CalendarEntry';
        export const deletePermission = 'DataAdmin:Calendar';
        export const insertPermission = 'DataAdmin:Calendar';
        export const readPermission = 'Read:Calendar';
        export const updatePermission = 'DataAdmin:Calendar';

        export declare const enum Fields {
            CalendarEntryId = "CalendarEntryId",
            CalendarCode = "CalendarCode",
            EntryDate = "EntryDate",
            Description = "Description",
            Exclude = "Exclude",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            CalendarCodeName = "CalendarCodeName",
            CalendarCodeRowId = "CalendarCodeRowId"
        }
    }
}
